import createAction from '../services/create-action';

export const SET_SITE_PAGES = 'sitePages/SET';
export const setSitePages = createAction(SET_SITE_PAGES);



// WEBPACK FOOTER //
// ./app/actions/set-site-pages.js